<template>
	<layout-admin>
		<pre v-html="resp" />
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		resp: {
			type: String,
			required: true,
		},
	},
};
</script>
